import edu_request from '@/utils/edu_request'
// 随堂练习题集
export function getTestApi(params) {
  return edu_request({
    url: 'subject/index/start',
    method: 'get',
    params
  })
}
// 课表重做错题
export function getAgainApi(params) {
  return edu_request({
    url: 'zkb/testing/again',
    method: 'get',
    params
  })
}
// 智能刷题对答案
export function getCheckApi(params) {
  return edu_request({
    url: 'subject/index/check',
    method: 'get',
    params
  })
}
// 试卷做题 结果页
export function getPaperExamResult(params) {
  return edu_request({
    url: 'paper/process/getResult',
    method: 'get',
    params
  })
}

// 新试卷
export function getNewExamApi(params) {
  return edu_request({
    url: 'subject/index/start',
    method: 'get',
    params
  })
}

// 新试卷交卷
export function getSubmitApi(params) {
  return edu_request({
    url: 'paper/process/submit',
    method: 'POST',
    // params
    data: qs.stringify(params)
  })
}

// 新试卷 查看解析试题
export function getSubmitAnalyse(params) {
  return edu_request({
    url: 'paper/process/analyse',
    method: 'GET',
    params
  })
}

// 获取销售策略数据
// export function getStategyById(params) {
//   return edu_request({
//     url: 'lesson/lesson/getStategyById',
//     method: 'GET',
//     params
//   })
// }
// 获取课程信息
export function getLesson(params) {
  return edu_request({
    url: 'lesson/lesson/getLesson',
    method: 'GET',
    params
  })
}
// 课表随堂练习
export function getTestSubmitApi(params) {
  return edu_request({
    url: 'zkb/testing/submit',
    method: 'POST',
    // params,
    data: qs.stringify(params)
  })
}

// 我的错题
export function myWrongList(params) {
  return edu_request({
    url: 'lesson/lesson/getScheduleByExercise',
    method: 'get',
    params: params
  })
}
